/* eslint-disable react/prop-types */
import { bool, func, number, shape } from 'prop-types';

import FeeAccumulative from './FeeAccumulative';
import FeeFixed from './FeeFixed';
import FeeTotal from './FeeTotal';
import FeeVideo from './FeeVideo';

const Fee = props => {
  const {
    consultDiscount,
    consultFee,
    isReadOnly,
    isFixed,
    onBack,
    onNext,
    userDiscount,
    setUserDiscount,
    consultId,
    isViewMode,
  } = props;
  if (isFixed) {
    return (
      <>
        <FeeFixed consultFee={consultFee} isViewMode={isViewMode} />
        <FeeTotal
          isReadOnly={isReadOnly}
          consultId={consultId}
          consultDiscount={consultDiscount}
          userDiscount={userDiscount}
          setUserDiscount={setUserDiscount}
          consultFee={consultFee}
          isViewMode={isViewMode}
        />
      </>
    );
  }

  if (consultFee.videoFee != null) {
    return <FeeVideo fee={consultFee} isReadOnly={isReadOnly} onNext={onNext} onBack={onBack} />;
  }

  return (
    <>
      <FeeAccumulative consultFee={consultFee} isViewMode={isViewMode} />
      {/* <FeePriority consultFee={consultFee} /> */}
      <FeeTotal
        isReadOnly={isReadOnly}
        consultId={consultId}
        consultDiscount={consultDiscount}
        userDiscount={userDiscount}
        setUserDiscount={setUserDiscount}
        consultFee={consultFee}
        isViewMode={isViewMode}
      />
    </>
  );
};

Fee.propTypes = {
  isFixed: bool,
  isReadOnly: bool,
  consultDiscount: number,
  onNext: func.isRequired,
  onBack: func.isRequired,
  consultFee: shape({}).isRequired,
};

Fee.defaultProps = {
  isFixed: false,
  isReadOnly: false,
  consultDiscount: 0,
};

export default Fee;
